// ProfessionaltNotes.jsx

// Components
import TextEditorSkills from '@/components/data/common/text/TextEditorSkills';

// Services
import { deleteProfessionalSkills, updateProfessionalSkills } from '@/services/schedulingService';

const ProfessionalSkills = ({ professionalID, skills, onUpdate }) => {
  async function deleteSkills() {
    await deleteProfessionalSkills(professionalID);
    if (onUpdate) onUpdate('');
  }

  async function updateSkills(newSkills) {
    await updateProfessionalSkills(professionalID, newSkills);
    if (onUpdate) onUpdate(newSkills);
  }

  return <TextEditorSkills value={skills} updateText={updateSkills} deleteText={deleteSkills} />;
};

export default ProfessionalSkills;
